import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const SUITABILITY_MECH_PLANTING = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName: 'FOR - Mechanical Planting Suitability',
  key: 'Suitability for Mechanical Planting',
  ruleId: '87',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
